import { Fragment as Fragment } from 'react';
import { createywkzgrq4l4xy as create } from './create.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createElementOrNull(block) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = create(Fragment, block);
  var tmp;
  if (!(this_0.props.children == null)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
//region block: exports
export {
  createElementOrNull as createElementOrNullndtuwori8mbn,
};
//endregion

//# sourceMappingURL=createElementOrNull.mjs.map
